import Ajv from "ajv";
import addFormats from "ajv-formats";

// Define the JSON schema for validation
export const templateSchema = {
  type: "object",
  required: ["id"],
  properties: {
    id: {
      type: "string",
    },
  },
  additionalProperties: true,
};

const ajv = new Ajv({ allErrors: true, strict: false });
addFormats(ajv);

export function validateJSON(data) {
  const validate = ajv.compile(templateSchema);
  const isValid = validate(data);
  const errors = validate.errors || [];
  return { isValid, errors };
}
